import { styled } from 'styled-components';

const FlexBoxHorizontal = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
export default FlexBoxHorizontal;
